import { isError, isBoolean, wrapArray } from 'gleam-shared/helpers/nodash'

export const ERROR_ATTR = 'data-error'
export const LOADED_ATTR = 'data-loaded'

const DEFAULT_ATTR = 'true'
const DEFAULT_ERROR = 'The resource failed to load!'

export function setState(el, attr, raw) {
  const val = isError(raw) ? stringifyError(raw) : raw
  el.setAttribute(attr, val)
}

export function setErrorState(el, error) {
  el.setAttribute(ERROR_ATTR, stringifyError(error))
}

export function setLoadedState(el) {
  el.setAttribute(LOADED_ATTR, true)
}

export default function whenStateChanges(el, {
  loaded: loadedAttrs = LOADED_ATTR,
  error: errorAttrs = ERROR_ATTR
} = {}) {
  if (!el) {
    return Promise.reject(new Error('An element is not given!'))
  }

  return new Promise((resolve, reject) => {
    const initialState = getState(el, loadedAttrs, errorAttrs)

    if (isBoolean(initialState)) {
      report(initialState)
      return
    }

    const observer = new MutationObserver(onEvent)
    observer.observe(el, {
      attributeFilter: [...wrapArray(loadedAttrs), ...wrapArray(errorAttrs)]
    })

    function clear() {
      observer.disconnect()
    }

    function onEvent() {
      const state = getState(el, loadedAttrs, errorAttrs)

      if (isBoolean(state)) {
        clear()
        report(state)
      }
    }

    function report(state) {
      if (state) {
        resolve(el)
      } else {
        reject(retrieveError(el, errorAttrs))
      }
    }
  })
}

function getState(el, loadedAttrs, errorAttrs) {
  if (isLoadedState(el, loadedAttrs)) {
    return true
  } else if (isErrorState(el, errorAttrs)) {
    return false
  }
}

function stringifyError(error) {
  if (!error) {
    return DEFAULT_ERROR
  } else if (error.message) {
    return error.message
  } else {
    return error
  }
}

function isErrorState(el, errorAttrs) {
  return wrapArray(errorAttrs).some((errorAttr) => {
    return el.hasAttribute(errorAttr)
  })
}

function isLoadedState(el, loadedAttrs) {
  return wrapArray(loadedAttrs).some((loadedAttr) => {
    return el.hasAttribute(loadedAttr)
  })
}

function retrieveError(el, errorAttrs) {
  const errorAttr = wrapArray(errorAttrs).find((errorAttr) => {
    return el.hasAttribute(errorAttr)
  })

  if (!errorAttr) {
    return
  }

  const attr = el.getAttribute(errorAttr)
  const message = attr && attr !== DEFAULT_ATTR ? attr : DEFAULT_ERROR

  return new Error(message)
}
